import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import Logo from './Logo';
import PrideLogo from './Logo.pride23';
export default withFeatureBranch({
    pride23: PrideLogo
})(Logo);
